import script from "./CurrentRequestForFunds.vue?vue&type=script&setup=true&lang=ts"
export * from "./CurrentRequestForFunds.vue?vue&type=script&setup=true&lang=ts"

import "./CurrentRequestForFunds.vue?vue&type=style&index=0&id=ce522518&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce522518"]])

export default __exports__